import { useMutation } from "@tanstack/react-query";
import { Button, Form, Input, message } from "antd";
import { FC } from "react";
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { setClientPhoneNumber } from "../../../../../services/store/slices/cart";
import { clientRegister } from "../../../../../network/clientSide";

interface ClientInfoStepProps {
  nextStep: () => boolean;
}

const ClientInfoStep: FC<ClientInfoStepProps> = ({ nextStep }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const addClientMutate = useMutation(clientRegister, {
    onError: (error: any) => {
      console.log(error);
      message.error(error?.response?.data?.message || "حدث خطأ");
      console.log("errorr", error);
    },
    onSuccess: (res: any) => {
      if (res?.code !== "ERR_BAD_REQUEST") {
        console.log("res", res);
        nextStep();
        message.success(
          intl.formatMessage({
            id: "OTPSENT",
            defaultMessage: "تم إرسال كود الى جوالك",
          })
        );
      } else {
        message.error(res?.response?.data?.message);
      }
      return;
    },
  });
  const handleAddClient = (values: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    password: string;
  }) => {
    const parsedPhoneNumber = parsePhoneNumber(values?.phoneNumber || "");
    dispatch(
      setClientPhoneNumber({
        phone: parsedPhoneNumber?.nationalNumber || null,
        phone_country_code: parsedPhoneNumber?.country || null,
      })
    );

    addClientMutate.mutate({
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      phone: parsedPhoneNumber?.nationalNumber || "",
      phone_country_code: parsedPhoneNumber?.country || "",
    });
  };
  return (
    <div className="mt-2 p-3  rounded ">
      <Form onFinish={handleAddClient} layout="vertical">
        <div className="flex justify-between gap-2 items-baseline">
          <div className="w-full">
            <Form.Item
              className="w-full"
              name={"firstName"}
              label={intl.formatMessage({
                id: "firstName",
                defaultMessage: "الاسم الأول",
              })}
              colon={false}
              required={false}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "firstNameRequired",
                    defaultMessage: "يجب إدخال الاسم الثاني",
                  }),
                },
                {
                  min: 3,
                  message: intl.formatMessage({
                    id: "nameLt3Chr",
                    defaultMessage: "الاسم  لا يقل عن 3 حروف",
                  }),
                },
              ]}
            >
              <Input className=" !border-none shadow" />
            </Form.Item>
          </div>
          <div className="w-full">
            <Form.Item
              name={"lastName"}
              label={intl.formatMessage({
                id: "lastName",
                defaultMessage: "الاسم الثاني",
              })}
              colon={false}
              required={false}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "lastNameRequired",
                    defaultMessage: "يجب إدخال الاسم الثاني",
                  }),
                },
                {
                  min: 3,
                  message: intl.formatMessage({
                    id: "nameLt3Chr",
                    defaultMessage: "الاسم  لا يقل عن 3 حروف",
                  }),
                },
              ]}
            >
              <Input className=" !border-none shadow" />
            </Form.Item>
          </div>
        </div>
        <div className="w-full">
          <Form.Item
            label={intl.formatMessage({
              id: "email",
              defaultMessage: "البريد الألكتروني",
            })}
            name={"email"}
            colon={false}
            required={false}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "emailRequired",
                  defaultMessage: "يجب إدخال بريد العميل ",
                }),
              },
              {
                type: "email",
                message: intl.formatMessage({
                  id: "invalidEmail",
                  defaultMessage: "البريد الالكتروني غير صحيح",
                }),
              },
            ]}
          >
            <Input className=" !border-none shadow" />
          </Form.Item>
        </div>
        <div className="w-full">
          <Form.Item
            name={"phoneNumber"}
            className=""
            label={intl.formatMessage({
              id: "phone",
            })}
            colon={false}
            required={false}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "phoneRequired",
                  defaultMessage: "يجب إدخال رقم الجوال ",
                }),
              },

              {
                validator: (_, value) => {
                  if (value && !isValidPhoneNumber(value)) {
                    return Promise.reject(
                      new Error(
                        intl.formatMessage({
                          id: "invalidPhoneNumber",
                          defaultMessage: "رقم جوال غير صحيح",
                        })
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <PhoneInputWithCountrySelect
              defaultCountry="SA"
              international
              style={{}}
              className=" !border-none shadow"
              onChange={() => {}}
              limitMaxLength={true}
            />
          </Form.Item>
        </div>

        <div className=" flex gap-1 w-full">
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={addClientMutate?.isLoading}
          >
            {intl.formatMessage({ id: "joinNow" })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ClientInfoStep;
